










































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

import formItem from '@/components/formItem.vue'

import imageClick from '@/components/itemOption/imageClick.vue'
import inputItem from '@/components/itemOption/inputItem.vue'
import pageParagraphItem from '@/components/itemOption/pageParagraphItem.vue'
import timeoutItem from '@/components/itemOption/timeoutItem.vue'
import pageFaqItem from '@/components/itemOption/pageFaqItem.vue'

import bottomMenuItem from '@/components/itemOption/bottomMenuItem.vue'
import gridMenuItem from '@/components/itemOption/gridMenuItem.vue'
import floorMenuItem from '@/components/itemOption/floorMenuItem.vue'

import layoutRepeatItem from '@/components/itemOption/layoutRepeatItem.vue'
import layoutLeftItem from '@/components/itemOption/layoutLeftItem.vue'
import layoutRightItem from '@/components/itemOption/layoutRightItem.vue'

import couponItem from '@/components/itemOption/couponItem.vue'
import goodsItem from '@/components/itemOption/goodsItem.vue'

import bannerItem from '@/components/itemOption/bannerItem.vue'
import scrollItem from '@/components/itemOption/scrollItem.vue'

import horizontalItem from '@/components/itemOption/horizontalItem.vue'
import verticalItem from '@/components/itemOption/verticalItem.vue'

import marqueeItem from '@/components/itemOption/marqueeItem.vue'

@Component({
  name: 'AppOption',
  components: {
    formItem,
    imageClick,
    inputItem,
    pageParagraphItem,
    timeoutItem,
    pageFaqItem,
    bottomMenuItem,
    gridMenuItem,
    floorMenuItem,
    layoutRepeatItem,
    layoutLeftItem,
    layoutRightItem,
    couponItem,
    goodsItem,
    bannerItem,
    scrollItem,
    horizontalItem,
    verticalItem,
    marqueeItem
  }
})
export default class AppOption extends Vue {
  @Prop({ default: null })
  private option: any

  private imageClickShow: Boolean = false
  private timeoutClickShow: Boolean = false

}
